import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { removeFromCart } from '../features/cartSlice';
import { FaTrash } from "react-icons/fa6";
import { IoTimeOutline } from "react-icons/io5";
import { FaRegCalendarAlt } from "react-icons/fa";
import { discountedPrice } from '../controller/control'
import { getCartList, deleteAllCart } from '../features/cartSlice'
//import { updateProductToUser } from '../features/userSlice';
//import { updateBookingSlot } from '../features/productSlice'
import { Toaster, toast } from 'sonner';

import Button from '@mui/material/Button';
import api from '../controller/api';

export default function CartBox({ setAlertCheck }) {
    const [selectedCoupon, setSelectedCoupon] = useState({})
    const [input, setInput] = useState("")
    const [payable, setPayabe] = useState(0)
    const [couponDiscount, setCouponDiscount] = useState()
    const [isCoupon, setIsCoupon] = useState(false)

    const [isAlert, setIsAlert] = useState(false);
    const [msgType, setMsgType] = useState('');
    const [alertText, setAlertText] = useState("");

    //const id = "A1b@C2d#E3"

    const dispatch = useDispatch()
    const cartList = useSelector(getCartList)

    const subTotal = cartList.reduce((acc, cur) => acc + cur.price, 0);
    const totalDiscount = cartList.reduce((acc, cur) => acc + cur.discount, 0) / cartList.length
    const finalTotal = discountedPrice(subTotal, totalDiscount)

    const alertMsg = (msg, type) => {
        setAlertText(msg);
        setMsgType(type);
        setIsAlert(true);
        const timer = setTimeout(() => {
            setAlertText('');
            setMsgType('');
            setIsAlert(false);
        }, 2000);
        return () => clearTimeout(timer)
    }

    const handleApplyCoupon = async () => {
        try {
            if (!input) {
                alertMsg('Enter coupon code!');
                setMsgType('warn-msg');
                return
            }
            const name = input

            const { data: res } = await api.get(`/coupon/${name}`)
            console.log(res?.data?.couponShow);

            if (!res?.data || !res?.data?.couponShow) {
                alertMsg('Coupon not valid');
                return setMsgType('warn-msg');
            }
            setSelectedCoupon(res?.data)
            setIsCoupon(true)
            alertMsg('Yay! Coupon applied');
            setMsgType('sucs-msg');
            couponApply(finalTotal, res?.data?.discount)
        } catch (error) {
            console.error(error)
            alertMsg('Oops! wrong coupon');
            setMsgType('warn-msg');
        }
    }

    const handleRemoveCoupon = () => {
        setInput("")
        setIsCoupon(false)
    }

    const handleRemoveItem = (cartId) => {
        dispatch(removeFromCart(cartId))
        //handleApplyCoupon()
        toast.success("Item removed:(")
    }

    const couponApply = (finalTotal, discount) => {
        const percent = finalTotal * discount / 100;
        const disCountedAmount = finalTotal - percent;
        setPayabe(Math.round(disCountedAmount))
        setCouponDiscount(Math.round(percent));
    }

    const handleUpdateProduct = async (data) => {
        try {
            await api.post("/booking/create", data)
            dispatch(deleteAllCart())
            setAlertCheck(true)
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        }
    }

    useEffect(() => {

    }, [])

    return (
        <>
            <Toaster richColors position="top-center" />
            <div className='cart-manage'>
                <div className='cart-details'>
                    {cartList.map((cart, i) => <div className='cart-content' key={i} style={{ width: "100%" }}>
                        <div className='cart-d-left'>
                            <div>
                                <img src={cart.productImgUrl
                                } alt={cart.title} className='cart-image' />
                            </div>
                            <div>
                                <h3>{cart.title}</h3>
                                <p><FaRegCalendarAlt /> {cart.bookingDate} at {cart.time}</p>
                                <p><IoTimeOutline /> {cart.timing} mins</p>
                            </div>
                        </div>
                        <div className='cart-d-right'>
                            <FaTrash className='clr-red' onClick={() => handleRemoveItem(cart.id)} />
                            <p><span className='line-through'>₹{cart.price}</span>₹{discountedPrice(cart.price, cart.discount)}</p>
                        </div>
                    </div>)}
                </div>
                <div className='cart-payment'>
                    {isAlert && <p className={msgType}>{alertText}</p>}
                    <h3>Order Summary</h3>
                    <p>Subtotal <span>₹{subTotal}</span></p>
                    <p>Discount <span>-₹{subTotal - finalTotal}</span></p>
                    <p>Total <span>₹{finalTotal}</span></p>
                    <div className='coupon-box'>
                        <h4>Promo Code</h4>
                        <input type='text' value={input} onChange={(e) => setInput(e.target.value)} placeholder='Enter Coupon' />
                        {isCoupon
                            ? <button onClick={handleRemoveCoupon}>Remove Coupon</button>
                            : <button onClick={handleApplyCoupon}>Apply Coupon</button>}
                    </div>
                    {isCoupon && <p>Coupon Discount <span>-₹{couponDiscount}({selectedCoupon.discount}%)</span></p>}
                    <p className='final-total'>Payable Total <span>₹{isCoupon ? payable : finalTotal}</span></p>
                    <Button variant="contained" className='full-width' onClick={() => handleUpdateProduct(cartList)}>
                        Chekout
                    </Button>
                </div>
            </div>
        </>
    )
}
